import Slider from "@/components/Slider";
import { useChannelLinearEpisodesQuery } from "@/hooks";
import Card from "@/components/Card/index";
import { SLIDER_MAX_NUM } from "@/lib/constants";

export default function ChannelLinearEpisodesSlider({
  id,
  ignoreMetaId,
  limit = SLIDER_MAX_NUM,
  ...props
}) {
  const { data, ...result } = useChannelLinearEpisodesQuery({
    variables: {
      offset: 0,
      limit,
      id,
      filter: {
        not: {
          meta_id: ignoreMetaId,
        },
      },
    },
  });
  const items = data?.channelLinearEpisodes;
  if (items?.data?.length === 0) return null;
  return <Slider {...props} {...result} itemComponent={Card} items={items} />;
}
